import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideMapPin, lucidePhone, lucideMail, } from '@ng-icons/lucide';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styles: [`
    :host {
      display: block;
    }
  `],
  providers: [
    provideIcons({
      lucideMapPin,
      lucidePhone,
      lucideMail,
    })
  ]
})
export class FooterComponent {
  readonly currentYear = new Date().getFullYear();
}
